import React, { useState } from 'react'
import { IconChevronRight } from '@tabler/icons-react'
import { cn } from 'src/enviroment/lib/utils'
import { ThinkingStep } from 'src/enviroment/api/chat/models'

type Props = {
  steps: ThinkingStep[]
  durationMessage?: string
  defaultOpen?: boolean
}

const ThinkingTrace: React.FC<Props> = ({ steps, durationMessage, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen)

  if (steps.length === 0) return null

  return (
    <div className="flex flex-col gap-2 py-1">
      <button type="button" onClick={() => setOpen((o) => !o)} className="flex items-center gap-1.5">
        <IconChevronRight
          className={cn('h-4 w-4 shrink-0 text-gray-400 transition-transform duration-200', open && 'rotate-90')}
          stroke={2}
        />
        <span className="text-base font-medium text-gray-400">{durationMessage ?? 'Thought process'}</span>
      </button>

      {open && (
        <div className="ml-[7px] flex flex-col">
          {steps.map((step, i) => {
            const done = step.status === 'done'
            const isLast = i === steps.length - 1
            return (
              <div key={step.step} className="flex gap-2.5">
                <div className="relative flex w-[6px] shrink-0 justify-center">
                  {!isLast && <span className="absolute top-[11px] h-full w-px bg-gray-600" />}
                  <span
                    className={cn(
                      'relative z-[1] mt-[7px] h-[6px] w-[6px] rounded-full',
                      done ? 'bg-light-green-500' : 'border border-gray-400 bg-copa-panel',
                    )}
                  />
                </div>
                <span className="pb-2 text-base text-gray-400">{step.step}</span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ThinkingTrace
